import { deconstructNode } from '~/libs/contentful/helpers'
import { TypeTopSkills } from '~/types/contentful/TypeTopSkills'

type TopSkillsProps = {
  topSkills: TypeTopSkills<'WITHOUT_UNRESOLVABLE_LINKS', string>
}

export const TopSkills = ({ topSkills }: TopSkillsProps) => {
  const { fields } = deconstructNode(topSkills) as TypeTopSkills<
    'WITHOUT_UNRESOLVABLE_LINKS',
    string
  >
  const { title, firstTab, secondTab } = fields

  const firstTabArray = firstTab ? firstTab.replace(/- /g, '').split('\n') : []
  const secondTabArray = secondTab ? secondTab.replace(/- /g, '').split('\n') : []

  return (
    <div className="flex flex-col items-start self-stretch mt-12 gap-6">
      <span className="text-m text-neutral-100 self-stretch">{title}</span>
      <div className="flex items-start gap-2 self-stretch">
        <ul className="hidden md:flex py-6 pl-8 px-4 flex-col gap-2 flex-1 self-stretch rounded-xl bg-neutral-5 list-disc">
          {firstTabArray.map((item: string, index: number) => (
            <li key={index} className="text-xs text-neutral-60 self-stretch">
              {item}
            </li>
          ))}
        </ul>
        <ul className="hidden md:flex py-6 pl-8 px-4 flex-col gap-2 flex-1 self-stretch rounded-xl bg-neutral-5 list-disc">
          {secondTabArray.map((item: string, index: number) => (
            <li key={index} className="text-xs text-neutral-60 self-stretch">
              {item}
            </li>
          ))}
        </ul>
        <ul className="flex md:hidden py-6 pl-8 px-4 flex-col gap-2 flex-1 self-stretch rounded-xl bg-neutral-5 list-disc">
          {[...firstTabArray, ...secondTabArray].map((item: string, index: number) => (
            <li key={index} className="text-xs text-neutral-60 self-stretch">
              {item}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
